import { Condition, Medication } from "@types-runway/condition";
import { LabExamRequirement } from "@types-runway/labExam";

export const labExamMinimumLeadDays = 21;

export const hasTimeForLabExam = (departureDate: string): boolean => {
  const parsed = new Date(departureDate);
  const departure = new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffInDays = Math.ceil(
    (departure.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
  );
  return diffInDays >= labExamMinimumLeadDays;
};

export const medicationRequiresLabExam = (medication: Medication | undefined): boolean => {
  return Boolean(medication?.metadata?.lab_exam_service_id);
};

export const extractLabExamRequirements = (conditions: Condition[]): LabExamRequirement[] => {
  const seen = new Set<string>();
  const requirements: LabExamRequirement[] = [];

  for (const condition of conditions) {
    const serviceId = condition.suggestedMedication?.metadata?.lab_exam_service_id;
    if (serviceId && !seen.has(serviceId)) {
      seen.add(serviceId);
      // "G6PD" is the only lab exam type supported by the backend currently.
      // When new exam types are added, derive labExamName from condition or serviceId mapping.
      requirements.push({ labExamName: "G6PD", serviceId });
    }
  }

  return requirements;
};
